import { type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { type StyledFontAwesomeIcons } from '@shared/plugin/icons/types';
import type { VMenuItem } from '../VMenu/VMenu.vue';

export type VSidebarIcon = StyledFontAwesomeIcons | FontAwesomeIconProps['icon'];

export type VSidebarIndicatorVariant = 'default' | 'danger';

export type VSidebarIndicator = {
  count?: number;
  variant?: VSidebarIndicatorVariant;
  icon?: FontAwesomeIconProps['icon'];
  tooltip?: string;
};

export type VSidebarItem = Omit<VMenuItem, 'icon' | 'badge'> & {
  icon?: VSidebarIcon;
  indicator?: VSidebarIndicator;
};

function isStyledIcon(icon: VSidebarIcon): icon is StyledFontAwesomeIcons {
  return typeof icon === 'object' && icon !== null && !Array.isArray(icon) && 'regular' in icon;
}

export function getIconForState(
  icon: VSidebarIcon,
  isActive: boolean,
): FontAwesomeIconProps['icon'] {
  return isStyledIcon(icon) ? (isActive ? icon.solid : icon.regular) : icon;
}
